import React from "react";
import { useApiQuery } from "@/lib/useApiQuery";
import { RefreshCcw, Sparkles } from "lucide-react";

/** Gemini's plain-English read on the period, built only from this building's figures. */
export function AiSummary({ siteId, start, days }) {
  const params = { start, days };
  const { data, loading, err, refetch } = useApiQuery(
    ["aiSummary", siteId, start, days],
    `/ai/sites/${encodeURIComponent(siteId)}/summary`,
    { params }
  );
  const state = {
    loading,
    text: data?.text || null,
    error: err || data?.error || (data?.reason === "no_data" ? "No metered data for this period yet." : null),
  };
  const load = () => refetch();

  return (
    <div className="mt-6 k-card p-5" data-testid="ai-summary">
      <div className="flex items-start gap-3">
        <Sparkles className="h-4 w-4 text-[#156F5B] mt-0.5 shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="k-label">What changed</div>
          {state.loading ? (
            <p className="mt-2 text-sm text-[#9CA3AF]" data-testid="ai-summary-loading">Reading the meters…</p>
          ) : state.text ? (
            <p className="mt-2 text-sm text-[#212121] leading-relaxed" data-testid="ai-summary-text">{state.text}</p>
          ) : (
            <p className="mt-2 text-sm text-[#9CA3AF]" data-testid="ai-summary-empty">{state.error || "No summary available."}</p>
          )}
        </div>
        <button onClick={load} disabled={state.loading} className="k-btn-outline shrink-0" data-testid="ai-summary-refresh">
          <RefreshCcw className={`h-3 w-3 ${state.loading ? "animate-spin" : ""}`} />
        </button>
      </div>
    </div>
  );
}
